import React, {PropTypes} from 'react';
import {inject, observer} from 'mobx-react';
import ItemList from '../../Form/ItemList';

@inject('qcFlagStore')
@observer
class QCFlagList extends React.Component {

  render() {
    const {qcFlagStore,children} = this.props;
    let data = qcFlagStore.items.map(({id, caption, description, color}) => ({
      id,
      caption,
      description,
      color: 
        <svg viewBox="0 0 20 20" x="10" width="20">
          <circle cx="10" cy="10" r="8" stroke="grey" strokeWidth="0.5px" fill={color} />
        </svg>
      // color: <i className='fa fa-circle' style={{color, border: '1px solid lightgrey', borderRadius: 100, padding: 0, height: 18, width: 18, fontSize: 18}}/>
    }));

    return (
      <div>
        <ItemList
        data ={data}
        store = {qcFlagStore}
        columns = {[
          {key: 'id', label: 'Id'},
          {key: 'caption', label: 'Caption'},
          {key: 'description', label: 'Description'},
          {key: 'color', label: 'Color'},
        ]}
        slug = {'qc/flag'}
        resource='maintenance'
        children={children}
        allowAdd
        allowEdit
        allowDelete
      />
      </div>
    );
  }
}

export default QCFlagList;



// WEBPACK FOOTER //
// ./src/components/QCRule/QCFlags/QCFlagList.js